import { createReducer, on } from "@ngrx/store";
import { RefLanguageDto } from "src/app/api/models";
import * as LanguageActions from "./language.actions";
import { resetLanguage } from './language.actions';

export const languageFeatureKey = "language";

export interface LanguageState {
	languageList: RefLanguageDto[];
	langToShow: string[];
}

export const initialState: LanguageState = {
	languageList: undefined,
	langToShow: undefined,
}

export const languageReducer = createReducer(
	initialState,
	on(LanguageActions.loadLanguageListSuccess, (state, { data }) => ({ ...state, languageList: data })),
	on(LanguageActions.loadLanguageListFailure, (state, action) => ({ ...state, loadingInsurersError: action.error })),
	on(LanguageActions.setLangToShow, (state, { data }) => ({ ...state, langToShow: data })),
	on(resetLanguage, () => initialState)

);